<template>
  <b-overlay :show="loading">
    <b-card-actions action-collapse title="Daftar Konsumen">
      <b-row class="align-items-end mb-1">
        <b-col md="3" sm="6" class="my-1">
          <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="5" sm="6" class="my-1">
          <b-form-group label="Cari" label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Cari toko / owner / no HP..."
                @keyup.enter="applySearch"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="clearSearch">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12" class="my-1 d-flex justify-content-md-end">
          <b-button
            v-if="allowCreate()"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            @click="add"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <!-- Detail -->
      <b-modal
        id="modaldetail"
        v-model="showModaldetail"
        ok-title="Tutup"
        ok-variant="secondary"
        ok-only
        centered
        size="lg"
        title="Detail Konsumen"
      >
        <b-row>
          <b-col md="4" sm="12">
            <strong>Tanggal</strong>
            <p>{{ form.tanggal }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>Kondisi</strong>
            <p>{{ form.kondisi_ket }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>Saldo</strong>
            <p>Rp {{ formatRupiah(form.saldo) }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>Nama Toko</strong>
            <p>{{ form.nama_toko }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>Nama Owner</strong>
            <p>{{ form.nama_owner }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>Bidang Bisnis</strong>
            <p>{{ form.bisnis_fokus }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>No. HP Konsumen</strong>
            <p>{{ form.no_hp }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong>Alamat</strong>
            <p>{{ form.alamat }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong class="d-block">Jenis Konsumen</strong>
            <p>{{ form.type_konsumen ? form.type_konsumen.nama : "-" }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong class="d-block">Bangunan</strong>
            <p>{{ form.tipe_bangunan }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong class="d-block">Kepemilikan Bangunan</strong>
            <p>{{ form.kepemilikan_bangunan }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong class="d-block">Lama Sewa Bangunan</strong>
            <p>{{ form.lama_sewa }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong class="d-block">Keterangan</strong>
            <p>{{ form.keterangan }}</p>
          </b-col>
          <b-col md="4" sm="12">
            <strong class="d-block">Sales</strong>
            <p>
              {{
                form.karyawan && form.karyawan.nama_lengkap
                  ? form.karyawan.nama_lengkap
                  : "-"
              }}
            </p>
          </b-col>
        </b-row>
      </b-modal>

      <!-- Form Tambah / Ubah -->
      <b-modal
        v-if="allowCreate() || allowUpdate()"
        id="modal-konsumen"
        v-model="showModal"
        centered
        size="md"
        :title="id ? 'Form Ubah Konsumen' : 'Form Tambah Konsumen'"
        hide-footer
      >
        <validation-observer ref="formajuankonsumen">
          <div class="d-flex mb-1">
            <feather-icon icon="PackageIcon" size="19" />
            <h6 class="ml-50 mb-0">Data konsumen</h6>
          </div>
          <b-alert v-if="!isSales" show variant="info" class="py-1 mb-2">
            Konsumen akan disimpan dengan status
            <strong>langsung approved</strong>
            (bypass alur ajuan konsumen).
          </b-alert>
          <b-form>
            <b-row>
              <b-col v-if="!isSales" cols="12">
                <b-form-group label="Sales" label-for="v-karyawan_id">
                  <validation-provider
                    #default="{ errors }"
                    name="karyawan_id"
                    :rules="{ required: true }"
                  >
                    <v-select
                      id="v-karyawan_id"
                      v-model="form.karyawan_id"
                      :options="karyawan_id"
                      :reduce="(option) => option.value"
                      label="text"
                      placeholder="Pilih sales..."
                      :class="{ 'is-invalid': errors.length > 0 }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Tanggal" label-for="v-tanggal">
                  <validation-provider
                    #default="{ errors }"
                    name="tanggal"
                    :rules="{ required: true }"
                  >
                    <b-form-input
                      id="v-tanggal"
                      v-model="form.tanggal"
                      :state="errors.length > 0 ? false : null"
                      type="date"
                      placeholder="Tanggal"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Tipe Konsumen" label-for="v-pelanggan_id">
                  <validation-provider
                    #default="{ errors }"
                    name="pelanggan_id"
                    :rules="{ required: true, min: 1 }"
                  >
                    <b-form-select
                      id="v-pelanggan_id"
                      v-model="form.pelanggan_id"
                      :state="errors.length > 0 ? false : null"
                      :options="pelanggan_id"
                      name="pelanggan_id"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Nama Toko" label-for="v-nama_toko">
                  <validation-provider
                    #default="{ errors }"
                    name="nama_toko"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-input
                      id="v-nama_toko"
                      v-model="form.nama_toko"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Nama Toko"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Nama Owner" label-for="v-nama_owner">
                  <validation-provider
                    #default="{ errors }"
                    name="nama_owner"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-input
                      id="v-nama_owner"
                      v-model="form.nama_owner"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Nama Owner"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Alamat" label-for="v-alamat">
                  <validation-provider
                    #default="{ errors }"
                    name="alamat"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-textarea
                      id="v-alamat"
                      v-model="form.alamat"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Alamat"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Nomor Hp/Telepon" label-for="v-no_hp">
                  <validation-provider
                    #default="{ errors }"
                    name="no_hp"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-input
                      id="v-no_hp"
                      v-model="form.no_hp"
                      :state="errors.length > 0 ? false : null"
                      placeholder="No HP"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Bisnis Toko" label-for="v-bisnis_fokus">
                  <validation-provider
                    #default="{ errors }"
                    name="bisnis_fokus"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-input
                      id="v-bisnis_fokus"
                      v-model="form.bisnis_fokus"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Sembako/Restoran/Lain-lain"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Tipe Bangunan" label-for="v-tipe_bangunan">
                  <validation-provider
                    #default="{ errors }"
                    name="tipe_bangunan"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-select
                      id="v-tipe_bangunan"
                      v-model="form.tipe_bangunan"
                      :state="errors.length > 0 ? false : null"
                      :options="tipe_bangunan"
                      name="tipe_bangunan"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="Kepemilikan Bangunan"
                  label-for="v-kepemilikan_bangunan"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="kepemilikan_bangunan"
                    :rules="{ required: true, min: 2 }"
                  >
                    <b-form-select
                      id="v-kepemilikan_bangunan"
                      v-model="form.kepemilikan_bangunan"
                      :state="errors.length > 0 ? false : null"
                      :options="kepemilikan_bangunan"
                      name="kepemilikan_bangunan"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Lama Sewa" label-for="v-lama_sewa">
                  <validation-provider
                    #default="{ errors }"
                    name="lama_sewa"
                    :rules="{ required: true, min: 1 }"
                  >
                    <b-form-input
                      id="v-lama_sewa"
                      v-model="form.lama_sewa"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Lama Sewa"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group label="Keterangan" label-for="v-keterangan">
                  <validation-provider
                    #default="{ errors }"
                    name="keterangan"
                    rules="required|min:2"
                  >
                    <b-form-textarea
                      id="v-keterangan"
                      v-model="form.keterangan"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Isi Keterangan"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>

        <div class="d-flex justify-content-end align-items-center mt-2">
          <b-button
            size="sm"
            class="mr-1"
            variant="outline-secondary"
            :disabled="saving"
            @click="showModal = false"
          >
            Batal
          </b-button>
          <b-button
            size="sm"
            variant="primary"
            :disabled="saving"
            @click.prevent="submit"
          >
            <b-spinner v-if="saving" small class="mr-50" />
            {{ saving ? "Menyimpan..." : id ? "Ubah" : "Simpan" }}
          </b-button>
        </div>
      </b-modal>

      <b-row>
        <b-col cols="12">
          <div
            v-if="!loading && !items.length"
            class="text-center text-muted py-4 border rounded"
          >
            Belum ada data konsumen
            <span v-if="filter"> untuk pencarian “{{ filter }}”</span>.
          </div>
          <b-table
            v-else
            striped
            small
            hover
            responsive
            :items="items"
            :fields="fields"
            show-empty
            empty-text="Tidak ada data"
          >
            <template #cell(no)="row">
              <strong>
                {{ (currentPage - 1) * perPage + row.index + 1 }}
              </strong>
            </template>

            <template #cell(konsumen)="{ item }">
              <div class="font-weight-bold">
                {{ item.nama_toko || "-" }}
              </div>
              <small class="d-block text-muted">
                {{ item.nama_owner || "-" }}
              </small>
              <small class="d-block text-muted">
                {{ item.no_hp || "-" }}
              </small>
            </template>

            <template #cell(sales)="{ item }">
              {{
                item.karyawan && item.karyawan.nama_lengkap
                  ? item.karyawan.nama_lengkap
                  : "-"
              }}
            </template>

            <template #cell(tipe)="{ item }">
              {{
                item.type_konsumen && item.type_konsumen.nama
                  ? item.type_konsumen.nama
                  : "-"
              }}
            </template>

            <template #cell(saldo)="{ item }">
              Rp {{ formatRupiah(item.saldo) }}
            </template>

            <template #cell(actions)="row">
              <b-button
                v-if="allowUpdate()"
                v-b-tooltip.hover.right="'Ubah'"
                size="sm"
                class="mr-50"
                variant="outline-info"
                @click="edit(row.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-dropdown
                size="sm"
                variant="outline-secondary"
                right
                no-caret
                boundary="viewport"
              >
                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" />
                </template>
                <b-dropdown-item-button @click="detail(row.item)">
                  <feather-icon icon="EyeIcon" class="mr-50" />
                  Detail
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  v-if="allowDelete()"
                  @click="remove(row.item)"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  Hapus
                </b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>

        <b-col
          cols="12"
          class="d-flex justify-content-between align-items-center mt-1"
        >
          <small class="text-muted">Total {{ totalRows }} data</small>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card-actions>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, confirmed, password } from "@validations";
import flatPickr from "vue-flatpickr-component";
import "@core/scss/vue/libs/vue-flatpicker.scss";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BTable,
  BOverlay,
  VBTooltip,
  BBadge,
  BModal,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea,
  BSpinner,
  BDropdown,
  BDropdownItemButton,
  BAlert,
} from "bootstrap-vue";

const APPROVED_STATUS = 3;

export default {
  components: {
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BCardActions,
    BModal,
    BTable,
    BOverlay,
    BBadge,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormTextarea,
    BSpinner,
    BDropdown,
    BDropdownItemButton,
    BAlert,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showModal: false,
      showModaldetail: false,
      id: null,
      required,
      password,
      email,
      confirmed,
      form: {
        karyawan_id: "",
        pelanggan_id: "",
        nama_toko: "",
        nama_owner: "",
        no_hp: "",
        bisnis_fokus: "",
        tipe_bangunan: "",
        kepemilikan_bangunan: "",
        lama_sewa: "",
        alamat: "",
        status: APPROVED_STATUS,
        keterangan: "",
        tanggal: "",
        kondisi_ket: "",
      },
      tipe_bangunan: [
        { value: "Permanen", text: "Permanen" },
        { value: "Non Permanen", text: "Non Permanen" },
      ],
      kepemilikan_bangunan: [
        { value: "Milik sendiri", text: "Milik sendiri" },
        { value: "Sewa", text: "Sewa" },
      ],
      pelanggan_id: [],
      karyawan_id: [],
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      totalRows: 0,
      currentPage: 1,
      filter: "",
      fields: [
        { key: "no", label: "No" },
        { key: "konsumen", label: "Nama Konsumen" },
        { key: "sales", label: "Sales" },
        { key: "tipe", label: "Tipe Konsumen" },
        { key: "saldo", label: "Saldo" },
        { key: "actions", label: "Aksi" },
      ],
      items: [],
      loading: false,
      saving: false,
    };
  },
  watch: {
    perPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();
    },
    currentPage() {
      this.getData();
    },
  },
  async mounted() {
    this.getkaryawan_id();
    this.getpelanggan_id();
    await this.getData();
    if (this.isSales && this.user && this.user.karyawan) {
      this.form.karyawan_id = this.user.karyawan.id;
    }
  },
  methods: {
    applySearch() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
        return;
      }
      this.getData();
    },
    clearSearch() {
      this.filter = "";
      this.applySearch();
    },
    emptyForm() {
      const firstTipe =
        this.tipe_bangunan && this.tipe_bangunan[0]
          ? this.tipe_bangunan[0].value
          : "Permanen";
      const firstKepemilikan =
        this.kepemilikan_bangunan && this.kepemilikan_bangunan[0]
          ? this.kepemilikan_bangunan[0].value
          : "Milik sendiri";

      return {
        karyawan_id: "",
        pelanggan_id: "",
        nama_toko: "",
        nama_owner: "",
        no_hp: "",
        bisnis_fokus: "Sembako",
        tipe_bangunan: firstTipe,
        kepemilikan_bangunan: firstKepemilikan,
        lama_sewa: "-",
        alamat: "",
        status: APPROVED_STATUS,
        keterangan: "--",
        tanggal: "",
        kondisi_ket: "",
      };
    },
    detail(item) {
      this.form = { ...item };
      if (this.form.type_konsumen) {
        this.form.pelanggan_id = this.form.type_konsumen.id;
      }
      this.id = item.id;
      this.showModaldetail = true;
    },
    edit(item) {
      this.id = item.id;
      this.form = {
        karyawan_id: item.karyawan
          ? item.karyawan.id
          : item.karyawan_id || "",
        pelanggan_id: item.type_konsumen
          ? item.type_konsumen.id
          : item.pelanggan_id || "",
        nama_toko: item.nama_toko || "",
        nama_owner: item.nama_owner || "",
        no_hp: item.no_hp || "",
        bisnis_fokus: item.bisnis_fokus || "",
        tipe_bangunan: item.tipe_bangunan || "",
        kepemilikan_bangunan: item.kepemilikan_bangunan || "",
        lama_sewa: item.lama_sewa || "",
        alamat: item.alamat || "",
        status: APPROVED_STATUS,
        keterangan: item.keterangan || "",
        tanggal: item.tanggal || "",
        kondisi_ket: item.kondisi_ket || "",
      };
      this.showModal = true;
    },
    add() {
      this.resetForm();
      this.showModal = true;
      if (this.isSales && this.user && this.user.karyawan) {
        this.form.karyawan_id = this.user.karyawan.id;
      }
    },
    remove(item) {
      this.$swal({
        title: "Anda yakin?",
        text: "Data konsumen ini akan dihapus",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          item.fungsi = 1;
          this.$store
            .dispatch("ajuankonsumen/save", [item])
            .then(() => {
              this.getData();
              this.displaySuccess({
                message: "Data Konsumen berhasil dihapus",
              });
              this.resetForm();
            })
            .catch((e) => {
              this.displayError(e);
              return false;
            });
        }
      });
    },
    resetForm() {
      this.id = null;
      this.form = this.emptyForm();
    },
    buildPayload() {
      let karyawanId = this.form.karyawan_id;
      if (this.isSales && this.user && this.user.karyawan) {
        karyawanId = this.user.karyawan.id;
      }

      const payload = {
        karyawan_id: karyawanId,
        pelanggan_id: this.form.pelanggan_id,
        nama_toko: this.form.nama_toko,
        nama_owner: this.form.nama_owner,
        no_hp: this.form.no_hp,
        bisnis_fokus: this.form.bisnis_fokus,
        tipe_bangunan: this.form.tipe_bangunan,
        kepemilikan_bangunan: this.form.kepemilikan_bangunan,
        lama_sewa: this.form.lama_sewa,
        alamat: this.form.alamat,
        keterangan: this.form.keterangan,
        tanggal: this.form.tanggal,
        status: APPROVED_STATUS,
      };
      if (this.id) {
        payload.id = this.id;
      }
      return payload;
    },
    submit() {
      if (this.saving) return false;
      this.$refs.formajuankonsumen.validate().then((success) => {
        if (!success) return false;

        const payload = this.buildPayload();
        this.saving = true;
        this.$store
          .dispatch("ajuankonsumen/save", [payload])
          .then(() => {
            this.resetForm();
            this.showModal = false;
            this.getData();
            this.displaySuccess({
              message: "Data Konsumen berhasil disimpan",
            });
          })
          .catch((e) => {
            this.displayError(e);
            return false;
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    getData() {
      const params = {
        status: APPROVED_STATUS,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      };
      if (this.isSales && this.user && this.user.karyawan) {
        params.karyawan_id = this.user.karyawan.id;
      }
      if (this.filter && String(this.filter).trim() !== "") {
        params.search = String(this.filter).trim();
      }

      this.loading = true;
      return this.$store
        .dispatch("ajuankonsumen/getData", params)
        .then((result) => {
          this.items = Array.isArray(result) ? result : [];
          this.totalRows =
            typeof result.total !== "undefined"
              ? Number(result.total)
              : this.items.length;
        })
        .catch((e) => {
          this.displayError(e);
          return false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getpelanggan_id() {
      this.$store
        .dispatch("tipekonsumen/getData", {})
        .then(() => {
          const tipekonsumen = JSON.parse(
            JSON.stringify(this.$store.state.tipekonsumen.datas)
          );
          tipekonsumen.map((item) => {
            item.value = item.id;
            item.text = item.nama || "";
          });
          this.pelanggan_id = tipekonsumen;
        })
        .catch((e) => {
          this.displayError(e);
          return false;
        });
    },
    getkaryawan_id() {
      this.$store
        .dispatch("karyawan/getData", {})
        .then(() => {
          const karyawan = JSON.parse(
            JSON.stringify(this.$store.state.karyawan.datas)
          );
          karyawan.map((item) => {
            item.value = item.id;
            const name = item.nama_lengkap;
            item.text =
              name == null || name === "null" || name === "undefined"
                ? ""
                : String(name).trim();
          });
          this.karyawan_id = karyawan;
        })
        .catch((e) => {
          this.displayError(e);
          return false;
        });
    },
  },
};
</script>
